import ReadOnlyAttribute from './ReadOnlyAttribute'

export default ReadOnlyAttribute
